import Vue from "vue";
import { find, findIndex } from 'lodash';
import { Post } from '../../../store/Models/Post';
import UBLogo from '@/components/UBLogo/UBLogo.vue';
var VueScrollTo = require('vue-scrollto');
//@ts-ignore
import HeadlineText from '@/pagebuilder-components/HeadlineText/HeadlineText';
// @ts-ignore
import PhotoDescription from '@/pagebuilder-components/PhotoDescription/PhotoDescription';
// @ts-ignore
import ImageGallery from '@/pagebuilder-components/ImageGallery/ImageGallery';
// @ts-ignore
import SocialShare from '@/components/social-share/SocialShare';
const moment = require('moment');
export default Vue.extend({
    name: 'BlogDetail',
    components: {
        HeadlineText,
        PhotoDescription,
        ImageGallery,
        'ub-logo': UBLogo,
        SocialShare
    },
    directives: {
        'scroll-to': VueScrollTo,
    },
    metaInfo() {
        return {
            // if no subcomponents specify a metaInfo.title, this title will be used
            title: this.pageTitle,
            // all titles will be injected into this template
            titleTemplate: '%s | Ultrabold Kommunikationsdesign GmbH',
            htmlAttrs: {
                lang: 'de',
                itemscope: 'true',
                itemtype: 'http://schema.org/Article'
            },
            meta: this.pageMeta
        };
    },
    mounted() {
        this.$store.dispatch('getContents');
        setTimeout(() => {
            if (!this.currentPost.id) {
                this.$router.push({ name: 'Error404' });
            }
        }, 1500);
    },
    computed: {
        pageMeta() {
            const meta = [];
            if (this.currentPost) {
                const title = this.currentPost.content.title;
                const teaser = this.currentPost.content.title;
                const image = this.currentPost.detail_photo_url || 'https://ultrabold.com/static/images/ub-logo.svg';
                meta.push({ 'name': 'description', 'content': teaser, 'vmid': 'description' });
                // Schema.org markup for Google+
                meta.push({ 'itemprop': 'name', 'content': title, 'vmid': 'itemprop:name' });
                meta.push({ 'itemprop': 'description', 'content': teaser, 'vmid': 'itemprop:description' });
                meta.push({ 'itemprop': 'image', 'content': image, 'vmid': 'itemprop:image' });
                // Open Graph data
                meta.push({ 'property': 'og:title', 'content': title, 'vmid': 'og:title' });
                meta.push({ 'property': 'og:description', 'content': teaser, 'vmid': 'og:description' });
                meta.push({ 'property': 'og:image', 'content': image, 'vmid': 'og:image' });
                meta.push({ 'property': 'og:site_name', 'content': 'Ultrabold Kommunikationsdesign GmbH', 'vmid': 'og:site_name' });
                meta.push({ 'property': 'article:published_time', 'content': moment(this.currentPost.published_on).format(), 'vmid': 'article:published_time' });
                meta.push({ 'property': 'article:modified_time', 'content': moment(this.currentPost.updated_on).format(), 'vmid': 'article:modified_time' });
                // Twitter Card data
                meta.push({ 'property': 'twitter:card', 'content': 'summary_large_image', 'vmid': 'twitter:card' });
                meta.push({ 'property': 'twitter:title', 'content': title, 'vmid': 'twitter:title' });
                meta.push({ 'property': 'twitter:description', 'content': teaser, 'vmid': 'twitter:description' });
                meta.push({ 'property': 'twitter:image', 'content': image, 'vmid': 'twitter:image' });
            }
            meta.push({ 'property': 'og:type', 'content': 'article', 'vmid': 'og:type' });
            meta.push({ 'property': 'og:url', 'content': 'https://ultrabold.com/' + this.$route.fullPath, 'vmid': 'og:url' });
            return meta;
        },
        pageTitle() {
            return this.currentPost ? this.currentPost.content.title : 'ultrabløg.';
        },
        pageUrl() {
            return;
        },
        pageTeaser() {
            return this.currentPost ? this.currentPost.content.teaser : '';
        },
        pageTeaserImage() {
            return this.currentPost ? this.currentPost.detail_photo_url : '';
        },
        activeIndex: function () {
            const searchParam = parseInt(this.$route.params.id);
            return findIndex(this.posts, { id: searchParam });
        },
        posts() {
            return this.$store.getters.posts;
        },
        currentPost() {
            const searchParam = parseInt(this.$route.params.id);
            return find(this.$store.getters.posts, { id: searchParam }) || new Post();
        },
        prevPost() {
            let prevIndex = this.activeIndex + 1;
            if (prevIndex) {
                return this.posts[prevIndex];
            }
        },
        nextPost() {
            let nextIndex = this.activeIndex - 1;
            if (nextIndex <= this.posts.length) {
                return this.posts[nextIndex];
            }
        }
    },
    methods: {
        prevSlide() {
            if (this.prevPost) {
                this.$router.push({ name: 'BlogDetail', params: { id: this.prevPost.id, slug: this.prevPost.slug } });
            }
        },
        nextSlide() {
            if (this.nextPost) {
                this.$router.push({ name: 'BlogDetail', params: { id: this.nextPost.id, slug: this.nextPost.slug } });
            }
        },
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/views/Blog/Detail/Detail.ts
// module id = null
// module chunks = 